module.exports = __webpack_public_path__ + "static/media/178.2166831c.jpg";